// eslint-disable-next-line import/prefer-default-export
export const whatsAppShareFacultyInfo = ({ name = '-', venue = '-', email = '-', mobile = '-' }) => {
  const textMessage = encodeURI(`Shared via VITspot App \nhttps://app.vitspot.com \n\n*${name}* \n*${venue}* \n*${email}* \n*${mobile}*`);
  return `https://api.whatsapp.com/send?text=${textMessage}`;
};
